var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "objectives-listing" },
    [
      _c("ListingWrapper", {
        attrs: { title: _vm.title, pagination: _vm.pagination },
        on: { "update-pagination": _vm.updateObjectivesListing },
        scopedSlots: _vm._u([
          {
            key: "listingActions",
            fn: function() {
              return [
                _c(
                  "CompassTooltip",
                  {
                    attrs: {
                      disabled: !_vm.createObjectiveButton.disabled,
                      content: _vm.createObjectiveButton.tooltip
                    }
                  },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.createObjectiveButton.label,
                        disabled: _vm.createObjectiveButton.disabled,
                        "data-bot": _vm.createObjectiveButton.dataBot
                      },
                      on: { click: _vm.handleCreateObjective }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "settings",
            fn: function() {
              return [
                _c("ObjectivesListingSettingsHeader", {
                  attrs: { filters: _vm.filters },
                  on: {
                    updateActiveFilters: _vm.updateActiveFilters,
                    updateFilter: _vm.updateFilter,
                    updateColumns: _vm.updateColumns,
                    updatePagination: _vm.updatePagination
                  }
                })
              ]
            },
            proxy: true
          },
          {
            key: "table",
            fn: function() {
              return [
                _vm.isLoading
                  ? _c("TableLoading")
                  : _c("ObjectivesListingTable", {
                      attrs: {
                        columns: _vm.columns,
                        rows: _vm.rows,
                        loading: _vm.isLoading,
                        hasActiveFilters: _vm.hasActiveFilters,
                        hasExpandableRows: _vm.hasExpandableRows,
                        createObjectiveButton: _vm.createObjectiveButton
                      },
                      on: {
                        resetFilters: _vm.resetFilters,
                        sort: _vm.updateObjectivesListing
                      }
                    })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("CompassDialog", {
        attrs: {
          size: "small",
          title: _vm.$t.__(
            "objectives.listing.ObjectivesListing.delete_objective"
          ),
          primaryAction: _vm.deleteParams.primaryAction,
          secondaryActions: _vm.deleteParams.secondaryActions,
          visible: _vm.deleteParams.displayConfirmDeleteDialog
        },
        on: {
          closed: _vm.resetDeleteParams,
          "update:visible": _vm.resetDeleteParams
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-regular" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t.__(
                            "objectives.listing.ObjectivesListing.confirm_deletion_of_an_objective"
                          )
                        ) +
                        "\n            "
                    )
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _vm.hasObjectiveToUpdate
        ? _c("ObjectiveUpdatePanel", {
            attrs: {
              objective: _vm.objectiveToUpdate,
              isVisible: _vm.hasObjectiveToUpdate
            },
            on: {
              close: function($event) {
                _vm.objectiveToUpdate = null
              },
              objectiveUpdated: function($event) {
                return _vm.updateObjectivesListing(_vm.currentQueryParams)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }